import script from "./ActiveAccountView.vue?vue&type=script&setup=true&lang=js"
export * from "./ActiveAccountView.vue?vue&type=script&setup=true&lang=js"

import "./ActiveAccountView.vue?vue&type=style&index=0&id=4b6b71fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b6b71fe"]])

export default __exports__